import {
  ApiResponse,
  UpdateUserAppSettingsDto,
  UserAppSettingsDto,
} from '@splitsecondconnect/ultramarine-shared';
import { HttpClient } from '@angular/common/http';
import { environment } from '@marineform/environment';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MANAGE_API_PATHS } from '../data';

@Injectable({
  providedIn: 'root',
})
export class UserAppSettingsService {
  #http = inject(HttpClient);

  #url(): string {
    return `${environment.ultramarineBaseUrl}/${MANAGE_API_PATHS.USER_APP_SETTINGS}`;
  }

  getSettings(): Observable<ApiResponse<UserAppSettingsDto>> {
    return this.#http.get<ApiResponse<UserAppSettingsDto>>(this.#url());
  }

  replaceSettings(
    dto: UpdateUserAppSettingsDto,
  ): Observable<ApiResponse<UserAppSettingsDto>> {
    return this.#http.put<ApiResponse<UserAppSettingsDto>>(this.#url(), dto);
  }
}
